import { Divider } from "@mui/material";
import { Fragment } from "react";

import { InfoField } from "./InfoField";
import { InfoPanelLayout } from "./InfoPanelLayout";
import { InfoSection } from "./InfoSection";

export type InfoFieldData = {
  label: string;
  value: string | undefined | null;
};

export type InfoPanelProps = {
  sections: InfoFieldData[][];
};

export const InfoPanel = ({ sections }: InfoPanelProps) => {
  return (
    <InfoPanelLayout>
      {sections.map((section, sectionIndex) => (
        <Fragment key={sectionIndex}>
          <InfoSection>
            {section.map((field, fieldIndex) => (
              <InfoField key={fieldIndex} label={field.label} value={field.value} />
            ))}
          </InfoSection>
          {sectionIndex < sections.length - 1 && <Divider />}
        </Fragment>
      ))}
    </InfoPanelLayout>
  );
};
